<template>
  <div class="fill-height">
    <v-card
        height="100%"
        class="rounded-lg d-flex flex-column"
    >
      <v-card-title class="text-break"><strong>{{ $t('cards.titles.dailyInspiration') }}</strong></v-card-title>
      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-if="!isLoading" class="fill-height">
        <v-carousel
            :continuous="true"
            :cycle="true"
            :show-arrows="false"
            delimiter-icon="fal fa-minus"
            dark
            hide-delimiter-background
            :interval="10000"
            height="100%"
        >
          <v-carousel-item
              v-for="(item, i) in inspiration"
              :key="i"
          >
            <div class="pb-12">
              <v-img
                  class="mb-3"
                  v-if="item.thumbnail"
                  :src="item.thumbnail"
              ></v-img>
              <div v-if="item.shortDescription" v-html="item.shortDescription"></div>
            </div>
          </v-carousel-item>
        </v-carousel>
        <!--<div class="text-h5">{{ inspiration }}</div>-->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-daily-inspiration",
  data() {
    return {
      isLoading: true,
      inspiration: []
    }
  },

  mounted(){
    this.fetchInspiration()
  },
  
  methods: {
    async fetchInspiration(){
      this.isLoading = true
      let inspiration = []
      inspiration = await api.newsItems.getList("tipoftheweek", this.$i18n.locale).then((res) => { return res.data })
      if (inspiration.length){
        this.inspiration = inspiration.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        for (const item of this.inspiration) {
          let image = await this.fetchImage(item.imageAssetId)
          let thumbnail = await this.fetchImage(item.thumbnailAssetId)
          item.image = image
          item.thumbnail = thumbnail
        }
      }
      this.isLoading = false
    },

    async fetchImage(id){
      if (id){
        return await api.newsItems.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            })
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>
